function resolveWsUrl() {
  try {
    // 1) Hard runtime override (useful in dev console/tests)
    if (typeof window !== 'undefined') {
      if (window.SFU_WS) return window.SFU_WS
      if (window.__SFU_WS__) return window.__SFU_WS__
    }

    // 2) Vite env override (configure per environment)
    // Examples:
    //   VITE_SFU_WS=wss://sfu.dnd.devforge.gr/ws
    //   VITE_SFU_HOST=sfu.dnd.devforge.gr  VITE_SFU_WS_PATH=/ws
    const env = typeof import.meta !== 'undefined' ? import.meta.env || {} : {}
    const direct = env.VITE_SFU_WS
    if (direct && typeof direct === 'string') return direct

    const host = env.VITE_SFU_HOST
    const path = env.VITE_SFU_WS_PATH || '/ws'
    if (host && typeof host === 'string') {
      const scheme =
        typeof window !== 'undefined' && window.location?.protocol === 'https:' ? 'wss' : 'ws'
      return `${scheme}://${host}${path}`
    }

    // 3) Derive from current origin (assumes reverse-proxy on same host)
    if (typeof window !== 'undefined' && window.location) {
      const isLocal = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname)
      const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws'
      const defaultPath = '/ws'
      if (isLocal) {
        // Local dev default
        return `ws://localhost:3001${defaultPath}`
      }
      // Production/staging default: same host via reverse proxy
      return `${scheme}://${window.location.host}${defaultPath}`
    }
  } catch {}
  // Fallback
  return 'ws://localhost:3001/ws'
}

export function getWsUrl() {
  return resolveWsUrl()
}

export const SFU_CONFIG = {
  wsUrl: resolveWsUrl(), // initial snapshot (back-compat)
  getWsUrl,
  // Optional auth: provide a function that returns a Firebase ID token or custom token
  async authToken() {
    try {
      // Prefer the app's user store if available (avoids importing firebase directly here)
      const { useUserStore } = await import('@/stores/userStore')
      const store = useUserStore()
      const u = store?.user || null
      if (u?.getIdToken) return await u.getIdToken()
    } catch {}
    return null
  }
}
